import { useCallback, useEffect } from 'react';
import { useAPI, useAuthenticatedAPI } from '../../../state';
import { useTerminologyTranslation } from '../../app/terminology';
import { useQueueAPI } from '../queue/selectors';
import { usePlanAPI, useWizardParams } from '../selectors';
import { RoleAppliesTo } from './types';
var ROLE_API = '/api/role/{queueId}';
var DELETE_ROLE_API = '/api/role/delete/{roleId}';
var ROLES_API = '/api/role';
export var ROLE_PLAN_OPTIONS_API = '/api/role/plan/{planId}/options';
var TRAINER_QA_API = '/api/report/wizard/trainer-qa';
export var useAddRoleAPI = function () {
  return useAuthenticatedAPI(ROLES_API, undefined, 'POST');
};
export var useRolePlanOptionsAPI = function () {
  var _a;
  var planData = usePlanAPI()[0];
  var queueData = useQueueAPI()[0];
  var planId = (_a = planData.data) === null || _a === void 0 ? void 0 : _a.basePlanId;
  var _b = useAuthenticatedAPI(ROLE_PLAN_OPTIONS_API, {
      planId: planId
    }, 'GET'),
    data = _b[0],
    fetchData = _b[1],
    clearData = _b[2];
  var fetchDataWrapper = useCallback(function () {
    if (planId || !!(queueData === null || queueData === void 0 ? void 0 : queueData.data)) {
      fetchData();
    }
  }, [fetchData, planId, queueData === null || queueData === void 0 ? void 0 : queueData.data]);
  return [data, fetchDataWrapper, clearData];
};
export var useClearRoleAPI = function (financial) {
  var queueId = useWizardParams().queueId;
  var _a = useAuthenticatedAPI(ROLE_API, {
      queueId: queueId
    }, 'DELETE'),
    data = _a[0],
    fetchData = _a[1],
    clearData = _a[2];
  var fetchDataWrapper = useCallback(function () {
    fetchData(undefined, {
      financial: financial
    });
  }, [fetchData, financial]);
  return [data, fetchDataWrapper, clearData];
};
export var useCopyRoleAPI = function (financial) {
  var queueId = useWizardParams().queueId;
  var _a = useAuthenticatedAPI(ROLE_API, {
      queueId: queueId
    }, 'POST'),
    data = _a[0],
    fetchData = _a[1],
    clearData = _a[2];
  var fetchDataWrapper = useCallback(function (source) {
    fetchData(undefined, {
      source: source,
      financial: financial
    });
  }, [fetchData, financial]);
  return [data, fetchDataWrapper, clearData];
};
export var useTrainerQaAPI = function () {
  var queueId = useWizardParams().queueId;
  var _a = useAPI(TRAINER_QA_API),
    data = _a[0],
    fetchData = _a[1],
    clearData = _a[2];
  var fetchDataWrapper = useCallback(function () {
    if (queueId) {
      fetchData(undefined, {
        queueId: queueId
      });
    }
  }, [fetchData, queueId]);
  return [data, fetchDataWrapper, clearData];
};
export var useDeleteRoleAPI = function (roleId) {
  return useAuthenticatedAPI(DELETE_ROLE_API, {
    roleId: roleId
  }, 'DELETE');
};
export var useRoleAppliesToOptions = function () {
  var t = useTerminologyTranslation('wizard').t;
  return Object.values(RoleAppliesTo).map(function (value) {
    return {
      id: value,
      name: t("supportStaff.roleAppliesToOptions.".concat(value))
    };
  });
};
export var useRoleDeleteState = function (selectedRoleId, setSelectedRoleId) {
  var _a = useDeleteRoleAPI(selectedRoleId),
    deleteRole = _a[0],
    fetchDeleteRole = _a[1],
    clearDeleteRole = _a[2];
  var _b = useQueueAPI(),
    fetchQueue = _b[1];
  useEffect(function () {
    if (selectedRoleId == null) return;
    fetchDeleteRole();
  }, [fetchDeleteRole, selectedRoleId]);
  useEffect(function () {
    if (deleteRole.data) {
      setSelectedRoleId(undefined);
      fetchQueue();
    }
    return clearDeleteRole;
  }, [clearDeleteRole, deleteRole.data, fetchQueue, setSelectedRoleId]);
  return {
    requestDelete: function (id) {
      if (deleteRole.requesting || id == null) return;
      setSelectedRoleId(id);
    },
    isDeleting: !!deleteRole.requesting
  };
};